"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSeries = void 0;
var BaseChart_1 = __importDefault(require("../interface/BaseChart"));
var merge_1 = __importDefault(require("lodash/merge"));
var render_1 = require("../render");
var index_1 = __importDefault(require("../constant/chart/index"));
var default_1 = __importDefault(require("../themes/default"));
/**
 * 创建series
 */
function createSeries(series) {
    var type = series.type;
    var options = {};
    Object.entries(render_1.BI).forEach(function (obj) {
        if (obj[0].toLowerCase() === type) {
            options = JSON.parse(JSON.stringify(obj[1]));
        }
    });
    return merge_1.default(options, series);
}
exports.createSeries = createSeries;
exports.default = (function (chart, page, component, config) {
    var options = chart.config;
    var inputOptions = JSON.parse(JSON.stringify(options));
    if (!options.series) {
        throw Error("请配置series");
    }
    if (Array.isArray(options.series)) {
        options.series = options.series.map(function (series) {
            return createSeries(series);
        });
    }
    else {
        options.series = createSeries(options.series);
    }
    var chartOption = {};
    var configKeys = [];
    Array.isArray(config === null || config === void 0 ? void 0 : config.extend) &&
        (config === null || config === void 0 ? void 0 : config.extend.map(function (item) {
            configKeys.push(item.split("-")[0]);
        }));
    Object.keys(options)
        .concat(configKeys)
        .forEach(function (key) {
        var configs = index_1.default[key];
        if (index_1.default[key]) {
            var extendTypeKey_1 = "";
            Array.isArray(config === null || config === void 0 ? void 0 : config.extend) &&
                (config === null || config === void 0 ? void 0 : config.extend.map(function (item) {
                    if (item.split("-")[0] === key) {
                        extendTypeKey_1 = item.split("-")[1] || "default";
                    }
                }));
            configs = index_1.default[key][extendTypeKey_1];
        }
        if (configs) {
            chartOption[key] = configs;
        }
    });
    chart.config = merge_1.default({}, chartOption, options);
    return new BaseChart_1.default(chart, page, (config === null || config === void 0 ? void 0 : config.theme) || default_1.default, component, inputOptions);
});
//# sourceMappingURL=factory.js.map